import { render } from "./CanadaM2BoDownload.vue?vue&type=template&id=8466e0f0&scoped=true"
import script from "./CanadaM2BoDownload.vue?vue&type=script&lang=js"
export * from "./CanadaM2BoDownload.vue?vue&type=script&lang=js"

import "./CanadaM2BoDownload.vue?vue&type=style&index=0&id=8466e0f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8466e0f0"]])

export default __exports__